export enum SegmentEventTypes {
  LEAD_SUBMITTED_PERSONAL_INFO_FORM = "lead_submitted_personal_info_form",
  FILTER_APPLIED = "Filter_Applied"
}

export const ANALYTICS_EVENT_SOURCE = "Product";

export type AnalyticsMetadataMapKeys =
  | "lead_created"
  | "lead_created_error"
  | "lead_attempted_form_api_call"
  | "lead_email_invalid"
  | "lead_rate_limited"
  | "lead_valid_email"
  | "lead_email_error"
  | "lead_passed_lead_scoring"
  | "lead_failed_lead_scoring"
  | "lead_scheduled_demo"
  | "lead_fetch_error"
  | "lead_filled_out_first_demo_form_section"
  | "second_demo_form_step_loaded"
  | "user_clicked_intercom_bubble"
  | "user_clicked_privacy_policy";

export interface AnalyticsMetadata<T extends AnalyticsMetadataMapKeys> {
  platformLocation?: string;
  [key: string]: any;
}

export enum PosthogFeatureFlagKeysEnum {
  ALLOW_RECORDING_SESSIONS = "record-20-percent-of-users-sessions",
  TENANT_AUTO_PAY_PAYMENT_FLOW = "autoPayPaymentFlow",
  TENANT_PAYMENT_WIZARD_BUTTONS_POSITION = "tenantPaymentProcessButtonsPosition"
}
